import React from 'react'
import {Form, Formik, FieldArray} from 'formik'
import * as yup from 'yup'
import {toast} from 'react-toastify'

import {Typography, Grid, Checkbox, IconButton} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined'

import {
  GRID_CONTAINER_SPACING,
  GridItem,
  SectorContainer,
  SaveButton,
  FormikTextField,
  FormikSelect,
} from './common'

import {REGEX_NUMBER_ONLY, PAYMENT_SETTING} from '../../../../../../constant'

const PAYMENT_ACCOUNT_TYPE_MENU = [
  {
    label: PAYMENT_SETTING.ACCOUNT.TYPE.LABEL.SAVING,
    value: PAYMENT_SETTING.ACCOUNT.TYPE.VALUE.SAVING,
  },
  {
    label: PAYMENT_SETTING.ACCOUNT.TYPE.LABEL.CURRENT,
    value: PAYMENT_SETTING.ACCOUNT.TYPE.VALUE.CURRENT,
  },
]
const PAYMENT_ACCOUNT_TYPE_VALUE = PAYMENT_SETTING.ACCOUNT.TYPE.VALUE

const {BANK} = PAYMENT_SETTING
const BANK_NAME_TH = BANK.NAME.TH

// all key from constants ex., ['BBL', 'CIMB',...]
const PAYMENT_BANK_VALUE = Object.keys(BANK_NAME_TH)
const PAYMENT_BANK_MENU = PAYMENT_BANK_VALUE.map(bankKey => ({
  label: BANK_NAME_TH[bankKey],
  value: bankKey,
}))

const validationSchema = yup.object({
  bankAccounts: yup.array().of(
    yup.object({
      bankName: yup.mixed().oneOf(PAYMENT_BANK_VALUE, 'กรุณาเลือกธนาคาร'),
      accountName: yup.string().required('กรุณาใส่ชื่อบัญชี'),
      accountNo: yup
        .string()
        .matches(REGEX_NUMBER_ONLY, {
          message: 'กรุณาใส่เลขที่บัญชีเป็นตัวเลขเท่านั้น',
        })
        .required('กรุณาใส่เลขที่บัญชี'),
      branch: yup.string().required('กรุณาใส่สาขา'),
      accountType: yup
        .string()
        .matches(/(SAVING|CURRENT)/, 'กรุณาเลือกประเภทบัญชี'),
    }),
  ),
  promptpayAccountName: yup.string().when('enablePromptpay', {
    is: true,
    then: yup.string().required('กรุณาใส่ชื่อบัญชี'),
  }),
  promptpayNumber: yup.string().when('enablePromptpay', {
    is: true,
    then: yup
      .string()
      .matches(REGEX_NUMBER_ONLY, {
        message: 'กรุณาใส่หมายเลขพร้อมเพย์เป็นตัวเลขเท่านั้น',
      })
      .required('กรุณาใส่หมายเลขพร้อมเพย์'),
  }),
})

class PaymentSector extends React.Component {
  render() {
    return (
      <SectorContainer>
        <Formik
          enableReinitialize
          initialValues={this.props.value}
          onSubmit={(values, {setSubmitting}) => {
            this.props
              .onSave({
                variables: {
                  projectId: this.props.project.id,
                  payment: {
                    bankAccounts: [...values.bankAccounts],
                    promptPay: {
                      accountName: values.enablePromptpay
                        ? values.promptpayAccountName
                        : '',
                      accountNo: values.enablePromptpay
                        ? values.promptpayNumber
                        : '',
                    },
                  },
                },
              })
              .then(re => {
                setSubmitting(false)
                toast.success('บันทึกข้อมูลวิธีการชำระเงินเรียบร้อยแล้ว', {
                  hideProgressBar: true,
                  position: toast.POSITION.BOTTOM_RIGHT,
                })
              })
          }}
          validationSchema={validationSchema}
          render={props => {
            const {
              isSubmitting,
              handleChange,
              handleBlur,
              touched,
              errors,
              values,
            } = props
            return (
              <Form>
                <FieldArray
                  name="bankAccounts"
                  render={arrayHelpers => {
                    return (
                      <React.Fragment>
                        <Typography variant="headline" gutterBottom>
                          ข้อมูลวิธีการชำระเงิน
                        </Typography>
                        <Grid
                          container
                          spacing={GRID_CONTAINER_SPACING}
                          alignItems="center"
                        >
                          <GridItem item xs={9} sm="auto">
                            <Typography variant="title">บัญชีธนาคาร</Typography>
                          </GridItem>
                          <GridItem item xs={3} sm={2}>
                            <IconButton
                              disabled={this.props.disabled}
                              onClick={() => {
                                if (values.bankAccounts.length < 6) {
                                  arrayHelpers.push({
                                    bankName: '',
                                    accountName: '',
                                    accountNo: '',
                                    branch: '',
                                    accountType:
                                      PAYMENT_SETTING.ACCOUNT.TYPE.VALUE.SAVING,
                                  })
                                }
                              }}
                              aria-label="Add"
                            >
                              <AddIcon />
                            </IconButton>
                          </GridItem>
                        </Grid>
                        {values.bankAccounts.map((bankAccount, index) => {
                          const bankName = (bankAccount.bankName || '').toUpperCase()
                          return (
                            <Grid
                              key={index}
                              container
                              alignItems="center"
                              spacing={GRID_CONTAINER_SPACING}
                            >
                              <GridItem item xs={12} sm={2}>
                                <FormikSelect
                                  label="ธนาคาร"
                                  lableId="bank-select-lable-id"
                                  required
                                  onBlur={handleBlur}
                                  touched={touched}
                                  errors={errors}
                                  value={
                                    bankName
                                  }
                                  disabled={this.props.disabled}
                                  onChange={handleChange}
                                  listItems={PAYMENT_BANK_MENU}
                                  name={`bankAccounts.${index}.bankName`}
                                />
                              </GridItem>
                              <GridItem item xs={12} sm={3}>
                                <FormikTextField
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  touched={touched}
                                  errors={errors}
                                  disabled={this.props.disabled}
                                  name={`bankAccounts.${index}.accountName`}
                                  value={bankAccount.accountName}
                                  label="ชื่อบัญชี"
                                  fullWidth
                                />
                              </GridItem>
                              <GridItem item xs={12} sm={2}>
                                <FormikTextField
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  touched={touched}
                                  errors={errors}
                                  disabled={this.props.disabled}
                                  name={`bankAccounts.${index}.accountNo`}
                                  value={bankAccount.accountNo}
                                  label="เลขที่บัญชี"
                                  fullWidth
                                />
                              </GridItem>
                              <GridItem item xs={12} sm={2}>
                                <FormikTextField
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  touched={touched}
                                  errors={errors}
                                  disabled={this.props.disabled}
                                  name={`bankAccounts.${index}.branch`}
                                  value={bankAccount.branch}
                                  label="สาขา"
                                  fullWidth
                                />
                              </GridItem>
                              <GridItem item xs={12} sm={2}>
                                <FormikSelect
                                  label="ประเภทบัญชี"
                                  lableId="account-type-select-lable-id"
                                  required
                                  onBlur={handleBlur}
                                  touched={touched}
                                  errors={errors}
                                  value={
                                    PAYMENT_ACCOUNT_TYPE_VALUE[
                                      bankAccount.accountType
                                    ]
                                  }
                                  onChange={handleChange}
                                  listItems={PAYMENT_ACCOUNT_TYPE_MENU}
                                  name={`bankAccounts.${index}.accountType`}
                                />
                              </GridItem>
                              <GridItem item xs={12} sm={1}>
                                <IconButton
                                  disabled={this.props.disabled}
                                  onClick={() => {
                                    return values.bankAccounts.length > 1
                                      ? arrayHelpers.remove(index)
                                      : null
                                  }}
                                  aria-label="Remove"
                                >
                                  <DeleteOutlinedIcon />
                                </IconButton>
                              </GridItem>
                            </Grid>
                          )
                        })}
                        <Grid
                          container
                          spacing={GRID_CONTAINER_SPACING}
                          alignItems="center"
                        >
                          <GridItem item xs={12} sm={12}>
                            <Typography variant="title" gutterBottom>
                              พร้อมเพย์
                            </Typography>
                          </GridItem>
                        </Grid>
                        <Grid
                          container
                          alignItems="center"
                          spacing={GRID_CONTAINER_SPACING}
                        >
                          <GridItem item xs="auto">
                            <Checkbox
                              disabled={this.props.disabled}
                              name="enablePromptpay"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              checked={values.enablePromptpay}
                            />
                          </GridItem>
                          <GridItem item xs={11} sm={2}>
                            <FormikTextField
                              required
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched}
                              errors={errors}
                              disabled={
                                !values.enablePromptpay || this.props.disabled
                              }
                              name="promptpayAccountName"
                              value={values.promptpayAccountName}
                              label="ชื่อบัญชี"
                              fullWidth
                            />
                          </GridItem>
                          <GridItem item xs={12} sm={3} md={2}>
                            <FormikTextField
                              required
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched}
                              errors={errors}
                              disabled={
                                !values.enablePromptpay || this.props.disabled
                              }
                              name="promptpayNumber"
                              value={values.promptpayNumber}
                              label="หมายเลขพร้อมเพย์"
                              fullWidth
                            />
                          </GridItem>
                        </Grid>
                        <Grid
                          container
                          direction="row-reverse"
                          spacing={GRID_CONTAINER_SPACING}
                        >
                          <GridItem item xs={12} sm={3}>
                            <SaveButton
                              type="submit"
                              variant="contained"
                              disabled={isSubmitting || this.props.disabled}
                              fullWidth
                            >
                              Save
                            </SaveButton>
                          </GridItem>
                        </Grid>
                      </React.Fragment>
                    )
                  }}
                />
              </Form>
            )
          }}
        />
      </SectorContainer>
    )
  }
}

export default PaymentSector



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/storeSettings/components/PaymentSector.js